import React, { FC } from 'react';
import Error500 from '../apps/Error500';

const Error500Page: FC = () => {
  return (
    <Error500 />
  );
};

export default Error500Page;
